import Vue from 'vue';

// Number Currency Formating
Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-IE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2 // force two decimals
    });
    return formatter.format(value);
  });




// WEBPACK FOOTER //
// ./src/filters.js